import Http from 'core/http/HttpService';
import EventBus from 'core/EventBus';

/**
 * Events:
 * @event PreAuthenticationEvent
 * @event AuthenticationSuccessEvent
 * @event AuthenticationFailureEvent
 * @event PreLogoutEvent
 * @event LogoutSuccessEvent
 * @event LogoutFailureEvent
 */
export default class AbstractUserService {
  configure(args) {
    this.config = args;
    this.configured = true;
  }

  login({ credentials }) {
    if (!this.configured) {
      throw Error('UserService is not configured');
    }

    EventBus.publish('PreAuthenticationEvent');
    function success({ statusCode, data }) {
      data = data ? JSON.parse(data) : data;
      console.log('Login success', 'Status', statusCode, 'Data', data);
      EventBus.publish('AuthenticationSuccessEvent', data);
      return {
        statusCode,
        data
      };
    }

    function error({ statusCode, data }) {
      console.log('Login error', 'Status', statusCode, 'Data', data);
      EventBus.publish('AuthenticationFailureEvent', data);
      return Promise.reject({
        statusCode,
        data
      });
    }

    return Http.post({
      url: this.config.login.url,
      contentType: this.config.login.contentType,
      data: {
        ...(this.config.login.data || {}),
        ...credentials
      },
      headers: this.config.login.headers,
    }).then(success, error);
  }

  logout() {
    if (!this.configured) {
      throw Error('UserService is not configured');
    }

    EventBus.publish('PreLogoutEvent');

    function success({ statusCode, data }) {
      console.log('User logout success', 'Status', statusCode, 'Data', data);
      EventBus.publish('LogoutSuccessEvent', data);
      return {
        statusCode,
        data
      };
    }

    function error({ statusCode, data }) {
      console.log('User logout error', 'Status', statusCode, 'Data', data);
      EventBus.publish('LogoutFailureEvent', data);
      return Promise.reject({
        statusCode,
        data
      });
    }

    return Http.get({
      url: this.config.logout.url,
      headers: this.config.logout.headers
    }).then(success, error);
  }

  changePassword({ request }) {
    const url = this.config.changePassword.url;
    return Http.put({
      url,
      data: request
    });
  }

  recoverPassword({ request }) {
    const url = this.config.recoverPassword.url;
    return Http.post({
      url,
      data: request
    });
  }

  loadSettings() {
    const url = this.config.settings.url;
    return Http.get({ url });
  }

  saveSettings({ settings }) {
    const url = this.config.settings.url;
    return Http.put({ url, data: settings });
  }
}
